import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import _ from 'lodash';
import { select } from '../../../configs/store';
import PropTypes from 'prop-types';
import formatOdds from '../../../utils/formatOdds';

import './BetConfirmation.scss';

class BetConfirmation extends PureComponent {

  componentDidMount(){
    const {
      numbersToBet: {
        events,
        permutations: {  odds }
      },
      close
    } = this.props;
    if (!odds || events.length<1){
      close();
    }
  }

  goBack = () => {
    const { close } = this.props;
    close();
  };

  async quickBet() {
    const {
      numbersToBet: { permutations },
      numbersToBet,
      setResetPermutations,
      quickBetSubmit,
      close
    } = this.props;
    await quickBetSubmit({ permutations, numbersToBet });
    /*
    TODO: NEED TO CHECK THE STATUS WHEN BETS ARE AVAILABLE ON DB
    */
    setResetPermutations();
    close();
  }

  handleButtonClick = (event) => {
    event.preventDefault();
    const { value } = event.target;
    const { history } = this.props;
    if (value === 'login') {
      history.push('#login');
    } else if (value === 'quickBet') {
      this.quickBet();
    } else {
      return; // Waiting for deposit design on the next sprint
    }
  }

  checkButton = () => {
    const {
      t,
      numbersToBet: {
        permutations: { totalStake }
      },
      activeWallet,
      divisor
    } = this.props;

    const text = `${ t('betConfirmation.quickBetButton') } ${ totalStake / divisor }`;
    let value = 'quickBet';
    if (!_.isEmpty(activeWallet) && activeWallet?.balance < totalStake) {
      value = 'deposit';
    } else if (_.isEmpty(activeWallet)) {
      value = 'login';
    }
    return (
      <button
        className="bet-confirmation__quickbet"
        value={ value }
        onClick={ this.handleButtonClick }
      >
        { text }
      </button>
    );
  };

  addToBetslip = async (e) => {
    e.preventDefault();

    const { addBet, numbersToBet, singleNumberEvent, setResetPermutations, close, changeSlip, divisor } = this.props;
    const regular = _.isEmpty(numbersToBet.bonus);
    let colors;
    if (_.isEmpty(numbersToBet.regular) && _.isEmpty(numbersToBet.bonus)) {
      return;
    }
    if (!regular) {
      colors = _.reduce(numbersToBet.selectedBonus,
        (o, key) => ({ ...o, [key]: 's' }),
        {}
      );
    } else {
      colors =  _.reduce(numbersToBet.selectedNumbers,
        (o, key) => ({
          ...o,
          [key]: singleNumberEvent.numberInfos.regular.colors[
            key - 1
          ].toLowerCase()
        }),
        {}
      );
    }

    for (const event of numbersToBet.events) {
      await addBet({
        eventCode: event.eventCode,
        providerCode: 1,
        odds: numbersToBet.permutations.odds,
        marketCode: regular
          ? numbersToBet.regular.marketCode
          : numbersToBet.bonus.marketCode,
        marketName: regular
          ? numbersToBet.regular.name
          : numbersToBet.bonus.name,
        tournamentName: singleNumberEvent.name,
        datetime: event.eventStart * 1000,
        sport: event.eventType,
        type: event.eventType,
        country: singleNumberEvent.country,
        anyNumbers: numbersToBet.selectedNumbers,
        permutationsCount: numbersToBet.permutations.permutationsCount,
        colors,
        selectedEvents: numbersToBet.events.length,
        productType: 4,
        rankedNumbers: regular ? [numbersToBet.selectedBankers] : [],
        numbersToPredictCount: numbersToBet.permutations.numbersToPredictCount,
        stake: parseFloat(numbersToBet.permutations.totalStake) / divisor,
        repetitionsCount: 1
      });
    }
    setResetPermutations();
    close();
    changeSlip(0);
  };

  render() {
    const {
      t,
      numbersToBet: {
        events,
        permutations: { permutationsCount, minimumReturn, odds }
      },
      selectedOddsType,
      divisor
    } = this.props;
    return (
      <div className="bet-confirmation">
        <div className="bet-confirmation__title">
          { t('betConfirmation.title') }
        </div>
        <div className="bet-confirmation__sub-title">
          { t('betConfirmation.subTitle') }
        </div>
        { this.checkButton() }
        <div className="bet-confirmation__bet-wrapper">
          <div className="bet-confirmation__bet-details">
            <span className="bet-confirmation__label">
              { t('betConfirmation.draws') }:
            </span>
            { events.length }
          </div>
          <div className="bet-confirmation__bet-details">
            <span className="bet-confirmation__label">
              { t('betConfirmation.oddsPerBet') }:
            </span>
            { odds ? formatOdds(odds, selectedOddsType) : 0 }
          </div>
          <div className="bet-confirmation__bet-details">
            <span className="bet-confirmation__label">
              { t('betConfirmation.bets') }:
            </span>
            { permutationsCount }
          </div>
          <div className="bet-confirmation__bet-details">
            <span className="bet-confirmation__label">
              { t('betConfirmation.maxWinPerBet') }:
            </span>
            { minimumReturn / divisor }
          </div>
        </div>
        <div className="bet-confirmation__buttons">
          <button onClick={ this.goBack } className="bet-confirmation__back">
            { t('betConfirmation.goBack') }
          </button>
          <button
            className="bet-confirmation__add-bet"
            onClick={ this.addToBetslip }
          >
            { t('betConfirmation.acceptAndAdd') }
          </button>
        </div>
      </div>
    );
  }
}

BetConfirmation.propTypes = {
  t: PropTypes.func,
  history: PropTypes.object,
  location: PropTypes.object
};

BetConfirmation.propTypes = {
  t: PropTypes.func,
  singleNumberEvent: PropTypes.object,
  numbersToBet: PropTypes.object,
  addBet: PropTypes.func,
  permutations: PropTypes.func,
  quickBetSubmit: PropTypes.func,
  history: PropTypes.object,
  selectedOddsType: PropTypes.string,
  setResetPermutations: PropTypes.func,
  activeWallet: PropTypes.object,
  selectedSlip: PropTypes.number,
  changeSlip: PropTypes.func,
  close: PropTypes.func,
  divisor: PropTypes.number
};

const selection = select((state) => ({
  activeWallet: state.auth.activeWallet
}));

const mapState = (state) => ({
  numbersToBet: state.events.numbersToBet,
  singleNumberEvent: state.events.singleNumberEvent,
  selectedOddsType: state.odds.selectedOddsType,
  divisor: state.betslip.divisor,
  ...selection(state)
});
const mapDispatch = (dispatch) => ({
  addBet: (obj) => dispatch.betslip.addBet(obj),
  quickBetSubmit: (obj) => dispatch.betslip.submitQuickBets(obj),
  setResetPermutations: () => dispatch.events.setResetPermutations(),
  changeSlip: (obj) => dispatch.betslip.changeSlip(obj)
});

export default withRouter(
  connect(mapState, mapDispatch)(withTranslation('common')(BetConfirmation))
);
